import axios from 'axios';
import { useTranslations } from 'next-intl';
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import Register from "../components/my-account/Register";

export default function RegisterPage() {
  const t = useTranslations('Account');

  return (
    <>
      <Header title={t('register')} />
      <main className="py-36 min-h-screen login-register-background">
        <div className="container mx-auto">
          <Register />
        </div>
      </main>
      <Footer />
    </>
  );
}

export async function getStaticProps() {
  const { data } = await axios.get(`${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}wp-json/beaver_next_wordpress/v1/settings`);
  const { data: studioData } = await axios.get(`${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}wp-json/beaver_next_wordpress/v1/acf_studio`);

  let lang = 'en';

  if (data?.language) {
    lang = data.language.split('_')[0];
  }

  const messages = await import(`../messages/${lang}.json`);

  return {
    props: {
      data: data || {},
      messages: messages.default,
      studioData: studioData || {},
    },
    revalidate: 300,
  };
}
